import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import Slide from 'material-ui/transitions/Slide';
import { SnackbarContent } from "material-ui";

//The point of having this "wrapper" for a snackbar is so that we can define
//specific styles and behavior for each type of notification.
//Odds are, successes will look and behave differently than errors.
//TODO: Add styles for success, maybe a nice check mark or something
const Transition = props => <Slide direction="up" {...props} />;

const SuccessNotification = ({ message, open, onClose, messageValue }) => {
    return (
        <div>
            {messageValue === 'Recipient' && 
            (<Snackbar
            open={open}
            onClose={onClose}
            transition={Transition}
            autoHideDuration={7000}
            >
                <SnackbarContent
                    style={{backgroundColor:'green'}}
                    message={message}
                />
            </Snackbar>) 
            }
            {messageValue !== 'Recipient' && 
            (<Snackbar
                open={open}
                onClose={onClose}
                transition={Transition}
                message={message}
                autoHideDuration={7000}
            />)
            }
            </div>
        
    );
};

export default SuccessNotification;
